export interface LegalCasesData {
    lastFetchedDate?: String;
    status?: string;
    legalCasesFiledAgainstCompanyOrDirector: CaseRow[];
    legalCasesFiledByCompanyOrDirector: CaseRow[];
}

type CaseRow = {
    name: string;
    cases: Case[];
    designation?: string;
};

type Case = {
    filedBy: string;
    filedAgainst: string;
    caseCategory: string;
    court: string;
    status: string;
    caseNum: string;
    nextHearingDate?: string;
    decisionDate?: string;
};
export const HEADERS = {
    CASE_DETAILS: 'caseDetails',
    FILED_BY: 'filedBy',
    FILED_AGAINST: 'filedAgainst',
    CASE_CATEGORY: 'caseCategory',
    COURT: 'court',
    STATUS: 'status',
    CASE_NUM: 'caseNum',
    REPORTS: 'docId',
    DATE: 'date',
};
const HEADER_LABELS = {
    [HEADERS.CASE_DETAILS]: 'Case Details',
    [HEADERS.FILED_BY]: 'Filed By',
    [HEADERS.FILED_AGAINST]: 'Filed Against',
    [HEADERS.CASE_CATEGORY]: 'Case Type',
    [HEADERS.COURT]: 'Court',
    [HEADERS.STATUS]: 'Status',
    [HEADERS.CASE_NUM]: 'Case No',
    [HEADERS.DATE]: 'Date',
};

const HEADER_LABELS_STAR = {
    [HEADERS.FILED_BY]: 'Filed By*',
    [HEADERS.FILED_AGAINST]: 'Filed Against*',
};

export function getHeadersFiledBy(isPDFReport = false) {
    return [
        {
            key: HEADERS.CASE_DETAILS,
            label: HEADER_LABELS[HEADERS.CASE_DETAILS],
        },
        {
            key: HEADERS.DATE,
            label: HEADER_LABELS[HEADERS.DATE],
        },
        {
            key: HEADERS.FILED_BY,
            label: HEADER_LABELS_STAR[HEADERS.FILED_BY],
        },
        {
            key: HEADERS.FILED_AGAINST,
            label: HEADER_LABELS[HEADERS.FILED_AGAINST],
        },
        {
            key: HEADERS.CASE_CATEGORY,
            label: HEADER_LABELS[HEADERS.CASE_CATEGORY],
        },
        ...(!isPDFReport
            ? [
                  {
                      key: HEADERS.REPORTS,
                      label: 'Report',
                  },
              ]
            : []),
    ];
}

export function getHeadersFiledAgainst(isPDFReport = false) {
    return [
        {
            key: HEADERS.CASE_DETAILS,
            label: HEADER_LABELS[HEADERS.CASE_DETAILS],
        },
        {
            key: HEADERS.DATE,
            label: HEADER_LABELS[HEADERS.DATE],
        },
        {
            key: HEADERS.FILED_AGAINST,
            label: HEADER_LABELS_STAR[HEADERS.FILED_AGAINST],
        },
        {
            key: HEADERS.FILED_BY,
            label: HEADER_LABELS[HEADERS.FILED_BY],
        },
        {
            key: HEADERS.CASE_CATEGORY,
            label: HEADER_LABELS[HEADERS.CASE_CATEGORY],
        },
        ...(!isPDFReport
            ? [
                  {
                      key: HEADERS.REPORTS,
                      label: 'Report',
                  },
              ]
            : []),
    ];
}
